import { getQaSelector } from '../../../../utils/common'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantDecisionPanel } from './ApplicantDecisionPanel'
import { ApplicantDocumentChecklist } from './ApplicantDocumentChecklist'
import { ApplicantIdentityWidget } from './ApplicantIdentityWidget'
import { ApplicantMatchingWidget } from './ApplicantMatchingWidget'
import { QA_NAME_APPLICANT_PROFILE_OVERVIEW } from './RentalPortalApplicantProfileTabOverview.constants'
import { getHasApplicantScreeningBlocks } from './RentalPortalApplicantProfileTabOverview.utils'

import * as styles from './RentalPortalApplicantProfileTabOverview.module.css'

function RentalPortalApplicantProfileTabOverview() {
  const { applicantData, isInitiated } = useApplicantProfileContext()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_PROFILE_OVERVIEW })}
      className={styles.RentalPortalApplicantProfileTabOverview}
    >
      <ApplicantIdentityWidget />
      <ApplicantMatchingWidget />
      {getHasApplicantScreeningBlocks(applicantData) ? (
        <ApplicantDocumentChecklist />
      ) : null}
      {!isInitiated || getHasApplicantScreeningBlocks(applicantData) ? (
        <ApplicantDecisionPanel />
      ) : null}
    </div>
  )
}

export default RentalPortalApplicantProfileTabOverview
